var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.as ?? 'button',{tag:"component",staticClass:"cz2__red-banner-button",class:_vm.headerFontClass,attrs:{"disabled":_vm.disabled}},[_c('h1',{staticClass:"cz2__red-banner-button__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }